import styled from '@emotion/styled'
import { colors } from '@mobi/component-library/Foundations'

export const QuickbetBadgeGreenStyled = styled.span({
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0 0.2rem',
  borderRadius: '0.2rem',
  color: colors.white,
  backgroundColor: colors.sushi[500],
  fontSize: '1rem',
  fontStyle: 'normal ',
  lineHeight: 1.3,
  fontWeight: 700,
  textTransform: 'uppercase',
})
